import { z } from "zod";

const CreateDeploymentTargetSchema = z.object({
  name: z
    .string()
    .min(1, { message: "Name is required." })
    .max(400, { message: "Name must not be longer than 400 characters." }),
  description: z.string().optional().nullable(),
  scope: z.enum(["root", "segment"], {
    message: "Target scope is required.",
  }),
  segmentId: z.string().uuid().optional().nullable(),
  targetCompliance: z
    .number({ message: "Target compliance is required." })
    .min(0, { message: "Target compliance must be between 0 and 1." })
    .max(1, { message: "Target compliance must be between 0 and 1." }),
});

export default CreateDeploymentTargetSchema;
